<template>
    <v-layout>
        <v-row justify="center">
            <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="black">
                        <v-toolbar-title>{{videoName}}
                            <span class="body-2 ml-9">{{spieldauer}} {{dateigroesse}}</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-row>
                        <v-col cols="12">
                            <v-card
                                    width="auto"
                                    height="700px"
                                    class="ma-2 backgroundPicHoch">
                                    <Moveable
                                            class="moveable"
                                            v-bind="moveable"
                                            @drag="handleDrag"
                                            @resize="handleResize"
                                            @scale="handleScale"
                                            @rotate="handleRotate"
                                            @warp="handleWarp"
                                    >
                                    <span class="hoch">
                                        <video controls src="/static/Video_hoch.mp4"></video>
                                    </span>
                                    </Moveable>
                                <!-- <v-row justify="center">
                                     <v-col cols="12" xs="12" sm="8" md="8" class="hoch text-center mt-8">
                                         <video class="borderVideo" controls src="/static/Video_hoch.mp4"></video>
                                     </v-col>
                                 </v-row> -->
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card>
            </v-dialog>
        </v-row>
    </v-layout>
</template>

<script>
// import Vue from 'vue'
import Moveable from 'vue-moveable';
export default {
  name: 'DialogShowVideoHoch',
  components: {Moveable},
  data () {
    return {
        dialog: false,
        videoName: 'Name des Videos',
        spieldauer: '3 Min.',
        dateigroesse: '7,24 MB',
        moveable: {
            draggable: true,
            throttleDrag: 0,
            resizable: false,
            throttleResize: 1,
            keepRatio: true,
            scalable: true,
            throttleScale: 0,
            rotatable: true,
            throttleRotate: 0,
        },
    }
  },
  methods: {
    open: function () {
      this.dialog = true
      // this.moveable['Resizable'] = true;
    },
      handleDrag({ target, left, top }) {
          console.log('onDrag left, top', left, top);
          target.style.left = `${left}px`;
          target.style.top = `${top}px`;
          console.log(target.style)
      },
      handleResize({
                       target, width, height, delta,
                   }) {
          console.log('onResize', width, height);
          delta[0] && (target.style.width = `${width}px`);
          delta[1] && (target.style.height = `${height}px`);
      },
      handleScale({ target, transform, scale }) {
          console.log('onScale scale', scale);
          target.style.transform = transform;
      },
      handleRotate({ target, dist, transform }) {
          console.log('onRotate', dist);
          target.style.transform = transform;
      },
      handleWarp({ target, transform }) {
          console.log('onWarp', target);
          target.style.transform = transform;
      },
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>
